export const appConfig = {
  orgName: import.meta.env.VITE_ORG_NAME || 'LeaveTrack',
  emailDomain: import.meta.env.VITE_ORG_EMAIL_DOMAIN || 'company.com',
  appTitle: import.meta.env.VITE_APP_TITLE || 'Leave Management System',
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL,
  cognito: {
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    redirectUri: `${window.location.origin}/callback`,
    logoutUri: `${window.location.origin}/login`,
  },
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000/v1',
  superHREmail: import.meta.env.VITE_SUPER_HR_EMAIL,
};
